export default function isPreventAllClientFields(prevent) {
  function action(context) {
    let state = context.state
    let { registrating: { current } } = state.get('client')
    let path = 'client.registrating.current'
    Object.keys(current).forEach(form => {
      Object.keys(current[form]).forEach(fieldKey => {
        let field = current[form][fieldKey]
        if (!field.client) {
          state.merge(`${path}.${form}.${fieldKey}`, {
            hidden: prevent
          })
        }
      })
    })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/isPreventAllClientFields.js